document.addEventListener('DOMContentLoaded', () => {
  const videoButtons = document.querySelectorAll('.shorts-video-preview');

  videoButtons.forEach(button => {
    button.addEventListener('click', () => {
      const videoId = button.dataset.videoId;
      const title = button.getAttribute('aria-label') || 'YouTube video';

      if (!videoId) return;

      const iframe = document.createElement('iframe');

      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`;
      iframe.title = title.replace('Відтворити відео: ', '');
      iframe.loading = 'lazy';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;

      button.replaceWith(iframe);
    });
  });
});